import { Translations } from './types';

export const en: Translations = {
  // Navigation
  nav: {
    features: 'Features',
    about: 'About',
    pricing: 'Pricing',
    support: 'Support',
    admin: 'Admin',
    downloadApp: 'Download App',
  },

  // Hero Section
  hero: {
    title: 'An inspiration app you\'ll *love*',
    subtitle: 'Daily inspiration, AI-generated images and personal reflections for a more motivated life',
    downloadIOS: 'Download for iOS',
    downloadIOSTestFlight: 'Download for iOS (TestFlight)',
    comingSoonAndroid: 'Coming soon for Android',
    freeTrialNote: 'No credit card required • 7 days free trial',
    note: 'No credit card required • 3 days free trial',
    mockupQuote: 'The best way to predict the future is to create it.',
    mockupAuthor: '- Peter Drucker',
    playVideo: 'Play video',
  },

  // Quote Example
  quote: {
    example: 'The best way to predict the future is to create it.',
    author: 'Peter Drucker',
    category: 'Leadership & Mindset',
  },

  // Features Section
  features: {
    title: 'Everything you need for daily inspiration',
    subtitle: 'Experience the complete journey of daily inspiration',
    screenshots: {
      categories: {
        title: 'Personalize Your Journey',
        description: 'Choose from 5 categories that resonate with your goals: Daily Inspiration, Sports, Leadership, Mindfulness, and Relationships.',
      },
      favorites: {
        title: 'Collect Your Favorites',
        description: 'Save the quotes that inspire you most and revisit them whenever you need motivation.',
      },
      share: {
        title: 'Share Your Inspiration',
        description: 'Spread positive energy by sharing beautifully designed quote cards with friends and family.',
      },
    },
    feature1: {
      title: 'Daily Inspiration',
      description: 'A new motivating quote every day from 5 categories: Inspiration, Sports, Leadership, Mindfulness and Relationships.',
    },
    feature2: {
      title: 'AI-Generated Images',
      description: 'Each quote is presented with a unique, AI-generated background image that perfectly matches the mood.',
    },
    feature3: {
      title: 'Personal Reflection',
      description: 'Write down your thoughts on each quote and track your personal development over time.',
    },
    feature4: {
      title: 'Smart Reminders',
      description: 'Receive your daily inspiration at the perfect time - customizable and discreet.',
    },
    feature5: {
      title: 'Multilingual',
      description: 'Available in German, English, Spanish and French - everything automatically adapted to your language.',
    },
    feature6: {
      title: 'Offline Capable',
      description: 'Your inspiration is always available, even without an internet connection.',
    },
    dailyInspiration: {
      title: 'Daily Inspiration',
      description: 'A new motivating quote every day from 5 categories: Inspiration, Sports, Leadership, Mindfulness and Relationships.',
    },
    aiImages: {
      title: 'AI-Generated Images',
      description: 'Each quote is presented with a unique, AI-generated background image that perfectly matches the mood.',
    },
    personalReflection: {
      title: 'Personal Reflection',
      description: 'Write down your thoughts on each quote and track your personal development over time.',
    },
    smartReminders: {
      title: 'Smart Reminders',
      description: 'Receive your daily inspiration at the perfect time - customizable and discreet.',
    },
    multilingual: {
      title: 'Multilingual',
      description: 'Available in German, English, Spanish and French - everything automatically adapted to your language.',
    },
    offline: {
      title: 'Offline Capable',
      description: 'Your inspiration is always available, even without an internet connection.',
    },
  },

  // Categories Section
  categories: {
    title: '5 categories for every area of life',
    daily: {
      name: 'Daily Inspiration',
      description: 'Motivating quotes for every day',
    },
    sport: {
      name: 'Sports & Discipline',
      description: 'Motivation for training and perseverance',
    },
    leadership: {
      name: 'Leadership & Mindset',
      description: 'Leadership and entrepreneurial thinking',
    },
    mindfulness: {
      name: 'Mindfulness & Balance',
      description: 'Inner peace and life balance',
    },
    relationships: {
      name: 'Relationships & Connection',
      description: 'Love, friendship and interpersonal connections',
    },
    inspiration: {
      title: 'Daily Inspiration',
      description: 'Motivating quotes for your everyday life',
    },
    sports: {
      title: 'Sports & Discipline',
      description: 'Strengthen your body and mind',
    },
  },

  // Pricing Section
  pricing: {
    title: 'Choose Your Plan',
    subtitle: 'Unlock all premium features',
    monthly: {
      title: 'Monthly',
      price: '€2.99',
      period: 'per month',
      features: [
        'Daily inspiration',
        'AI-generated images',
        'Personal journal',
        'Customizable reminders',
        'All categories',
        'Export features',
        'No ads',
      ],
      cta: 'Choose Monthly',
    },
    yearly: {
      title: 'Yearly',
      price: '€14.99',
      period: 'per year',
      badge: 'Best Value',
      features: [
        'Daily inspiration',
        'AI-generated images',
        'Personal journal',
        'Customizable reminders',
        'All categories',
        'Export features',
        'No ads',
      ],
      cta: 'Choose Yearly',
      savings: 'Save 58%',
    },
  },

  // Footer
  footer: {
    copyright: 'All rights reserved.',
    madeWith: 'Made with ❤️ in Germany',
    product: {
      title: 'Product',
      features: 'Features',
      pricing: 'Pricing',
      admin: 'Admin',
    },
    support: {
      title: 'Support',
      help: 'Help',
      contact: 'Contact',
      faq: 'FAQ',
    },
    legal: {
      title: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms of Service',
      imprint: 'Imprint',
      eula: 'End User License Agreement',
    },
  },
};